export const dropdownLinkStyle = {
  general: {
    paddingLeft: "1.5rem",
    paddingRight: ".25rem",
    paddingTop: ".25rem",
    paddingBottom: ".25rem",
    textDecoration: "none"
  }
};
